import { useState } from 'react';
import CustomImage from '../custom-image/CustomImage';
import CardWrapper from './CardWrapper';
import IconUI from '../icon/IconUI';
import IconPlus from '../icon/IconPlus';

export default function CardHighContent({ card, category, colorIndex }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!card) return null;

  const handleCardClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <CardWrapper
      className={`cardHighContent ${isExpanded ? 'cardHighContent--expanded' : ''}`}
      colorIndex={colorIndex}
    >
      <button
        type="button"
        className={`cardHighContent-inner`}
        onClick={handleCardClick}
        aria-expanded={isExpanded}
        aria-label={`${card.heading || 'Card'} - ${isExpanded ? 'showing details' : 'click to expand'}`}
      >
        {/* {card.image && ( */}
        <div className="cardHighContent-media">
          <CustomImage
            image={card?.image}
            fill={true}
            sizes={'(max-width: 768px) 100vw, 33vw'}
          />
        </div>
        {/* )} */}

        <div className="cardHighContent-text">
          {card.heading && (
            <h3
              className="cardHighContent-heading h4"
              dangerouslySetInnerHTML={{ __html: card.heading }}
            />
          )}
        </div>
        <div
          className="cardHighContent-textOverlay colorDynamicBg"
          aria-hidden={!isExpanded}
        >
          {card.heading && (
            <h3
              className="cardHighContent-heading h4"
              dangerouslySetInnerHTML={{ __html: card.heading }}
            />
          )}
          {card.description && (
            <p
              className="cardHighContent-description"
              dangerouslySetInnerHTML={{ __html: card.description }}
            ></p>
          )}
        </div>

        {/* Plus morphs into minus (same animation as Accordion) rather than
            swapping two SVGs — see .iconPlus in _icons.scss. */}
        <IconUI theme={isExpanded ? 'dark' : 'light'} padding>
          <IconPlus open={isExpanded} />
        </IconUI>
      </button>
    </CardWrapper>
  );
}
